import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../Modal/Modal';
import GenericButton from '../GenericButton';
import icon from '../../../images/red-trash-icon.svg';

const deleteAllModalStyle = {
  width: '334px',
  height: '191px',
  left: '35%',
  top: '20%',
};

const headerModalStyles = {
  height: '64px',
  padding: '20px 31px',
};

const closeButtonStyle = {
  display: 'none',
};

const bodyStyles = {
  padding: '15px 31px',
};

const GlobalDelete = props => {
  let deleteAllModal;
  const deleteOperation = () => {
    if (props.deleteType === 'single') {
      props.singleDeleteOperation(props.gridType, props.type, props.index);
    } else {
      deleteAllModal.show();
    }
  };
  let deleteComp;
  if (props.infoBox) {
    deleteComp = (
      <React.Fragment>
        <div className="delete-comp" onClick={deleteOperation} height="40px">
          <img src={icon} className="red-delete-selected" alt="delete icon" />
          <span style={{ paddingLeft: '10px' }}>{props.label}</span>
        </div>
      </React.Fragment>);
  } else {
    deleteComp = (<React.Fragment>
      {
        props.label === 'Delete'
          ? <span className="delete-selected" onClick={deleteOperation} />
          : <div className="delete-comp"><span onClick={deleteOperation}>{props.label}</span></div>
      }

      <Modal
        title={`Delete All ${props.type === 'row' ? 'Row' : 'Column'}s`}
        ref={node => (deleteAllModal = node)}
        dialogStyles={deleteAllModalStyle}
        headerStyles={headerModalStyles}
        closeButtonStyle={closeButtonStyle}
        bodyStyles={bodyStyles}
      >
        <span> {`Do you want to delete All ${props.type === 'row' ? 'Row' : 'Column'}s ? `} </span>
        <div className="button-group margin-top-15 delete-button-group">
          <GenericButton
            name="Cancel"
            title="Cancel"
            btnStyle="button cancel-button"
            onBtnClick={() => {
              deleteAllModal.hide();
            }}
          />
          <GenericButton
            name="Confirm"
            title="Confirm"
            btnStyle="button confirm-button"
            onBtnClick={() => {
              props.deleteAllOperation(props.gridType, props.type);
              deleteAllModal.hide();
            }}
          />
        </div>
      </Modal>
    </React.Fragment>);
  }
  return deleteComp;
};
GlobalDelete.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string,
  infoBox: PropTypes.bool,
  gridType: PropTypes.string,
  deleteType: PropTypes.string,
  className: PropTypes.string,
};

export default React.memo(GlobalDelete);
